import { Pipe, PipeTransform } from '@angular/core';

/**Pure pipe che verifica se un nodo dell'albero delle risorse è attivo/selezionato */
@Pipe({
  name: 'activeTreeNode'
})
export class ActiveTreeNodePipe implements PipeTransform {

  /**
   * Metodo dell'interfaccia PipeTransform che effettua il controllo
   * @param selectId {number} identificativo dell'elemento selezionato
   * @param nodeId {number} identificativo del nodo da verificare
   * @returns la classe active se l'identificativo corrisponde, altrimenti una stringa vuota
   */
  transform(selectId: number, nodeId: number): string {
    return selectId === nodeId ? 'active' : '';
  }

}
